<template>
  <div class="flex flex-col items-center text-center py-24">
    <TickCircleOutlineIcon color="#229150" :width="64" :height="64" aria-hidden="true" class="mb-16" />
    <h1 class="font-medium text-m1 mb-8">{{ title }}</h1>
    <p class="text-body text-gray-body mb-24">{{ subtitle }}</p>
    <Button
      v-if="isPopupMode"
      value="Continue Searching"
      variant="primary"
      size="medium"
      class="w-full mb-16"
      @click="$emit('continue-searching')"
    />
    <Button v-else value="Continue Searching" variant="primary" size="medium" class="w-full mb-16" href="/availability/search" />
    <Button
      v-if="!isBasic"
      value="View conversation"
      variant="outlined"
      size="medium"
      class="w-full"
      :href="`/messages?uuid=${recipientUuid}`"
    />
    <Button v-else value="Upgrade to Message" variant="outlined" size="medium" class="w-full" href="/upgrade/pricing" />
  </div>
</template>

<script lang="ts">
import TickCircleOutlineIcon from '@/graphics/icons/TickCircleOutlineIcon.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'RecruitSitterSentView',
  components: { TickCircleOutlineIcon, Button },
  props: {
    recipientName: {
      type: String,
      required: true,
    },
    recipientUuid: {
      type: String,
      required: true,
    },
    isBasic: {
      type: Boolean,
      default: false,
    },
    isPopupMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title(): string {
      if (this.isBasic) {
        return `Job shared with ${this.recipientName}`;
      }
      return 'Invite sent!';
    },
    subtitle(): string {
      if (this.isBasic) {
        return 'Search for more sitters or continue the conversation in messages.';
      }
      return `${this.recipientName} has been invited to apply to your job.`;
    },
  },
};
</script>
